import { render, staticRenderFns } from "./SettingsSlackCallback.vue?vue&type=template&id=77ea4913&scoped=true&lang=pug&"
import script from "./SettingsSlackCallback.vue?vue&type=script&lang=js&"
export * from "./SettingsSlackCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ea4913",
  null
  
)

export default component.exports